<template>
  <NoticeCard
    :class="b()"
  >
    <el-row
      type="flex"
      align="middle"
    >
      <div
        v-if="data.state !== 1"
        :class="b('uploading')"
      >
        <SymbolIcon
          icon="icondengdai"
          :size="30"
        />
        <div>
          <div :class="b('tips-title')">
            {{ $t('notice.dataProcessing') }}
          </div>
          <div :class="b('upload-tips-dec')">
            {{ $t('notice.other') }}
          </div>
          <el-progress
            :show-text="false"
            :stroke-width="4"
            :percentage="progressNum"
            style="margin-bottom: 12px;"
          >
          </el-progress>
        </div>
      </div>

      <div
        v-if="data.state !== 0 && data.checkResult == true"
        :class="b('complete-have-fail')"
      >
        <div :class="b('tips-complete')">
          <SymbolIcon
            icon="iconchenggong1"
            :size="30"
          />
          <div :class="b('tips-complete-text')">
            <div :class="b('tips-title')">
              {{ $t('notice.importComplete') }}
            </div>
            <div :class="b('tips-num')">
              <template>
                <span v-html="importSuccessText" />
              </template>
              <template v-if="data.errorRow">
                <span v-html="importFailText" />
              </template>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="data.state !== 0 && data.checkResult == false"
        :class="b('fail')"
      >
        <div :class="b('tips-fail')">
          <SymbolIcon
            icon="iconshibai"
            :size="30"
          />
          <div :class="b('tips-complete-text')">
            <div :class="b('tips-title')">
              {{ $t('notice.importFailTitle') }}
            </div>
            <div :class="b('tips-dec')">
              {{ data.errorMsg }}
            </div>
          </div>
        </div>
      </div>
    </el-row>
    <el-row
      type="flex"
      align="bottom"
    >
      <el-button
        v-if="data.state !== 0 && data.checkResult == false"
        :class="b('action-submit')"
        type="primary"
        size="mini"
        @click="openImportIssue(false)"
      >
        {{ $t('notice.againImport') }}
      </el-button>
      <div>
        <el-button
          v-if="data.state !== 0 && data.checkResult == true"
          :class="b('continue-import')"
          size="mini"
          @click="openImportIssue(true)"
        >
          {{ $t('notice.continueImport') }}
        </el-button>
        <el-button
          v-if="data.state !== 0 && data.checkResult == true"
          :class="b('action-submit')"
          type="primary"
          size="mini"
          @click="downloadErrorFile"
        >
          {{ data.errorRow ? $t('notice.downloadErrorFile') : $t('notice.yes') }}
        </el-button>
      </div>
    </el-row>
  </NoticeCard>
</template>
<script>
import theme from '@zk/theme/lib/variables.scss';
import NoticeCard from '@/components/notice/NoticeCard';
import { downloadOfUrl } from '@zk/framework-vue';
import { queryImportOrExportResult } from '@/api/message';
import { debounce } from 'lodash';

export default {
  name: 'ImportNoticeCard',
  components: {
    NoticeCard
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  bemNS: theme.bemNS,
  /*socketEvents: {
    importResult(data) {
      if(this.id === data.uuid) {
        this.data = data ;
      }
    }
  },*/
  data() {
    return {
      startTimer: '',
      data: {},
      successRow: 0
    };
  },
  computed: {
    progressNum() {
      const { doneRow, totalRow } = this.data || {};
      return parseInt((doneRow / totalRow) * 100) > 100 ? 100 : parseInt((doneRow / totalRow) * 100) || 0;
    },
    state() {
      return this.data?.state;
    },
    importSuccessText() {
      const num = this.data?.errorRow ? this.successRow : this.totalRow;
      return this.$t('notice.importSuccess', {
        successRow: this.$tc('common.count.num', num, {
          num: `<span class="${this.b('text-green')}">${num}</span>`
        })
      });
    },
    importFailText() {
      const num = this.data?.errorRow;
      return this.$t('notice.importFail', {
        errorRow: this.$tc('common.count.num', num, {
          num: `<span class="${this.b('text-red')}">${num}</span>`
        })
      });
    }
  },
  watch: {
    data: {
      handler(value) {
        this.$parent.showClose = value.state === 1;
        if (value && value.checkResult === true) {
          this.successRow = parseInt(value.totalRow - value.errorRow) ;
          this.totalRow = value.totalRow;
        }
      },
      immediate: true
    },
    state(value) {
      if (value) {
        this.eventBus.$emit('project:member-change');
        // eslint-disable-next-line
        this.eventBus.$emit('issue:import-refresh', this.data.checkResult ? { importSucWorkAccount:this.successRow, importFailWorkAccount:this.data?.errorRow || 0, 
          nextAction:'关闭' } : { fail_reason:this.data.errorMsg, next_action:'关闭' });
      }
    }
  },
  created() {
    this.load();
    this.time();
  },
  destroyed() {
    clearTimeout(this.set);
  },
  methods: {
    time() {
      this.set = setTimeout(async() => {
        if (this.data.state !== 1) {
          await this.load();
          this.time();
        }
      }, 1000);
    },
    load: debounce(async function() {
      const res = await queryImportOrExportResult({ 'uuid': this.id });
      if (res) {
        this.data = res;
      }
      if (res.state !== 0) {
        this.$store.commit('app/SET_ISSUE_UPLOADING', false);
      }
    }, 500),
    downloadErrorFile() {
      if (this.data.errorRow){
        const url = this.data.checkResult ? this.data.fileName : '';
        url ? downloadOfUrl(url) : '';
        // eslint-disable-next-line
        this.$track.send('Import_success', { importSucWorkAccount:this.successRow, importFailWorkAccount:this.data?.errorRow || 0, 
          nextAction:'下载错误文件' }, true);
        return;
      }
      this.$parent.close();
      // eslint-disable-next-line
      this.$track.send('Import_success', { importSucWorkAccount:this.successRow, importFailWorkAccount:this.data?.errorRow || 0, 
        nextAction:'知道啦' }, true);
    },
    openImportIssue(success) {
      this.eventBus.$emit('issue:import');
      setTimeout(() => {
        this.$parent.close();
      }, 500);
      if (success){
        // eslint-disable-next-line
        this.$track.send('Import_success', { importSucWorkAccount:this.successRow, importFailWorkAccount:this.data?.errorRow || 0, 
          nextAction:'继续导入' }, true);
        return;
      }
      this.$track.send('Import_fail', { fail_reason:this.data.errorMsg, next_action:'重新导入' }, true);
    }
  }
};
</script>

<style lang="scss">
@include b(import-notice-card) {
  // padding: 0 0 0 7px;
  .zk-import-notice-card__text-green {
    color: #0EB83A;
    margin: 0 !important;
  }
  .zk-import-notice-card__text-red {
    color: #E02020;
    margin: 0 !important;
  }
  svg {
    margin-right:  var(--m-small);
    flex-shrink: 0;
  }
  .zk-import-notice-card__uploading {
    display: flex;
    .zk-import-notice-card__upload-tips-dec {
      font-weight: var(--weight-font-Regular);
      color: var(--font-color-2);
      margin: 4px 0 12px 0;
    }
  }
  .zk-import-notice-card__tips-dec {
    font-weight: var(--weight-font-Regular);
    color: var(--font-color-1);
    margin: 4px 0 12px 0;
  }
  .zk-import-notice-card__tips-title {
    font-size: var(--size-font-6);
    font-weight: var(--notice-card-title-weight);
    color: var(--font-color-1);
    line-height: 24px;
  }
  .zk-import-notice-card__tips-complete {
    display: flex;
    .zk-import-notice-card__tips-num {
      font-weight: var(--weight-font-Regular);
      margin: 4px 0 12px 0;
      span {
        margin-right:  var(--m-small);
      }
    }
  }
  .zk-import-notice-card__tips-fail {
    display: flex;
    .zk-import-notice-card__tips-num {
      font-weight: var(--weight-font-Regular);
    }
  }
  .zk-import-notice-card__tips-complete-text{
    .zk-import-notice-card__tips-dec {
      width: 100%;
      word-break: break-word;
    }
  }
  &:before {
    background-color: var(--main-bg-color);
  }
  // .el-button {
  //   height: 30px;
  // }
  .zk-import-notice-card__action-submit {
    margin-left: 12px;
  }
  .el-row--flex.is-align-bottom {
    justify-content: flex-end;
  }
}
</style>
